import { useMemo } from 'react';

import { Editor, IAllProps as EditorProps } from '@tinymce/tinymce-react';

import LayoutWithMenu from '../Layout/LayoutWithMenu';

const HtmlEditor = () => {
  const fields = [
    { key: 'firstName', label: 'First Name', value: 'Luiz' },
    { key: 'lastName', label: 'Last Name', value: 'Oliveira' },
    { key: 'abn', label: 'ABN', value: '123456789' },
    { key: 'companyName', label: 'Company Name', value: 'April9' },
  ];

  const dragCallback = (e: any) => {
    e.dataTransfer.setData(
      'text/html',
      `<span class="dynamic-variable" contentEditable=false>@${e.target.textContent}</span>`,
    );
  };

  const handleEditorChange = (content: string, _editor: any) => {
    let html = content;

    fields?.forEach(field => {
      html = html.split(`@${field.label}`).join(field.value);
    });

    const previewHtml = document.getElementById('previewHtml');
    if (previewHtml) {
      previewHtml.innerHTML = html;
    }
  };

  const initProps: EditorProps['init'] = useMemo(() => {
    const images_upload_handler: NonNullable<
      EditorProps['init']
    >['images_upload_handler'] = async (blobInfo, _progress) => {
      const file = blobInfo.blob();
      const base64 = blobInfo.base64();

      return Promise.resolve(`data:${file.type};base64,${base64}`);
    };

    return {
      body_class: 'Editor',
      height: 500,
      forced_root_block: '',
      paste_data_images: true,
      images_upload_handler: images_upload_handler,
      content_css: '/htmlEditor.css',
      plugins: [
        'advlist',
        'autolink',
        'lists',
        'link',
        'image',
        'charmap',
        'preview',
        'anchor',
        'searchreplace',
        'visualblocks',
        'code',
        'fullscreen',
        'insertdatetime',
        'media',
        'table',
        'help',
        'wordcount',
      ],
      toolbar:
        'undo redo | blocks | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help | image | code',
      paste_as_text: false,
      automatic_uploads: false,
      convert_urls: true,
      relative_urls: false,
    };
  }, []);

  return (
    <LayoutWithMenu>
      <br />
      {/* ========= Fields ========= */}
      {fields?.map(field => (
        <div
          key={field.key}
          id={field.key}
          draggable="true"
          onDragStart={dragCallback}
          style={{ border: 'solid 1px #CCC', padding: '5px', width: '300px' }}
        >
          {field.label}
        </div>
      ))}
      <br />
      <Editor
        apiKey="jb71mu3c2qv846cltedqwiw5scosvlv8btn8la6m8lpqvgip"
        init={initProps}
        onEditorChange={handleEditorChange}
      />
      <br />
      {/* ========= Preview ========= */}
      <div id="previewHtml" />
    </LayoutWithMenu>
  );
};

export default HtmlEditor;
